<template>
  <div>
    <q-card class="auth-card relative-position">
      <q-card-main>
        <check-mark></check-mark>

        <h4 class="text-center">{{ $t('email_confirmed_title') }}</h4>

        <p class="text-center">{{ $t('email_confirmed_body') }}</p>
      </q-card-main>
    </q-card>
  </div>
</template>

<script>
  import CheckMark from 'components/Common/Animations/Checkmark.vue'
  import { UserClient } from 'src/api/Users'
  import { createErrorFromResponse } from 'src/utils/error'

  export default {
    beforeRouteEnter (to, from, next) {
      let token = to.params.token

      new UserClient()
        .confirmEmailChange(token)
        .then(() => next(vm => setTimeout(() => { vm.$router.push({ name: 'login' }) }, 5000)))
        .catch(error => {
          createErrorFromResponse(error)

          next({ name: 'login' })
        })
    },

    components: {
      CheckMark
    }
  }
</script>
